var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c("div", {}, [
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "has-text-centered getMainDiv container top40" },
        [
          _c("br"),
          _vm._v(" "),
          _c("img", {
            staticClass: "ownYourWordsImg",
            attrs: {
              src: require("@/assets/img/ownyourwordsyellow.png"),
              width: "150"
            }
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNotAvail,
                  expression: "showNotAvail"
                }
              ],
              staticClass: "bandSearch  bottom20 top40 has-text-black"
            },
            [
              _vm._v("Sorry, the slink "),
              _c("b", [_vm._v('"' + _vm._s(_vm.msgSlink) + '"')]),
              _vm._v(" is taken.")
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "is-size-4 top30 has-text-black" }, [
            _c("div", { staticClass: "band" }, [
              _c("span", { staticClass: "isPoppins has-text-white" }, [
                _c("b", [
                  _vm._v(
                    "Enter the slink you would like to reserve to get started:"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "is-size-5 has-text-white top10" }, [
              _vm._v("(It can be a word or short phrase with no spaces)")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "is-inline-block " },
            [_c("get-started", { ref: "gs", attrs: { get: true } })],
            1
          ),
          _vm._v(" "),
          _c("br")
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "slantedDiv has-background-darkTurk top160" }, [
      _c("div", { staticClass: "   has-text-centered" }, [
        _c("div", { staticClass: "container has-text-left" }, [
          _c("div", { staticClass: "is-size-3 has-text-white " }, [
            _c("img", {
              attrs: { src: require("@/assets/img/chevronsY.png"), width: "27" }
            }),
            _c("b", { staticClass: "left3" }, [_vm._v("Pricing")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "has-text-yell is-size-4 top20" }, [
            _c("b", [_vm._v("Try 30 days for free")]),
            _vm._v(" (no credit card)")
          ]),
          _vm._v(" "),
          _vm.$root.showPlans
            ? _c(
                "div",
                {
                  staticClass: "columns top20 mobileMargin pricingBG",
                  attrs: { "data-aos": "fade-left" }
                },
                [
                  _c("div", { staticClass: "column top20" }, [
                    _c("div", { staticClass: "has-text-centered planPanel" }, [
                      _c("div", { staticClass: "planTitleHome" }, [
                        _c("b", [_vm._v("BASIC")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top40" }, [
                        _c("div", { staticClass: "is-size-3" }, [
                          _c("b", [
                            _vm._v("Slink + "),
                            _c("span", { staticClass: "has-text-yell" }, [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.SmallYearly.limit) +
                                  " subslinks"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("-")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("SlinkPage")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("QR codes")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _vm._v("2 million redirects per year")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "is-size-4 top40 priceContainer" },
                          [
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.SmallMonthly.price)
                              )
                            ]),
                            _vm._v("/mth "),
                            _c("br"),
                            _c("span", { staticClass: "is-size-6" }, [
                              _vm._v("or")
                            ]),
                            _c("br"),
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.SmallYearly.price)
                              )
                            ]),
                            _vm._v("/yr")
                          ]
                        ),
                        _vm._v(" "),
                        _c("br")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column top20" }, [
                    _c("div", { staticClass: "has-text-centered planPanel" }, [
                      _c("div", { staticClass: "planTitleHome" }, [
                        _c("b", [_vm._v("STANDARD")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top40" }, [
                        _c("div", { staticClass: "is-size-3" }, [
                          _c("b", [
                            _vm._v("Slink + "),
                            _c("span", { staticClass: "has-text-yell" }, [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.MediumYearly.limit) +
                                  " subslinks"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("Analytics")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("SlinkPage")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("QR codes")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _vm._v("3 million redirects per year")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "is-size-4 top40 priceContainer" },
                          [
                            _vm._v("$$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.MediumMonthly.price)
                              )
                            ]),
                            _vm._v("/mth "),
                            _c("br"),
                            _c("span", { staticClass: "is-size-6" }, [
                              _vm._v("or")
                            ]),
                            _c("br"),
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.MediumYearly.price)
                              )
                            ]),
                            _vm._v("/yr")
                          ]
                        ),
                        _vm._v(" "),
                        _c("br")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column top20" }, [
                    _c("div", { staticClass: "has-text-centered planPanel" }, [
                      _c("div", { staticClass: "planTitleHome" }, [
                        _c("b", [_vm._v("PREMIUM")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top40" }, [
                        _c("div", { staticClass: "is-size-3" }, [
                          _c("b", [
                            _vm._v("Slink + "),
                            _c("span", { staticClass: "has-text-yell" }, [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.LargeYearly.limit) +
                                  " subslinks"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("Analytics")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("SlinkPage")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("QR codes")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _vm._v("5 million redirects per year")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "is-size-4 top40 priceContainer" },
                          [
                            _vm._v("$$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.LargeMonthly.price)
                              )
                            ]),
                            _vm._v("/mth "),
                            _c("br"),
                            _c("span", { staticClass: "is-size-6" }, [
                              _vm._v("or")
                            ]),
                            _c("br"),
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.LargeYearly.price)
                              )
                            ]),
                            _vm._v("/yr")
                          ]
                        ),
                        _vm._v(" "),
                        _c("br")
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "has-text-white is-size-4 has-text-centered top20" },
            [
              _c("b", [
                _vm._v("Your account may hold as many Slinks as you like")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "has-text-white is-size-5 has-text-centered top30" },
            [
              _vm._v(
                "*Please contact us for corporate plans with higher subslink counts"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "has-text-white is-size-6 has-text-centered top5" },
            [
              _vm._v(
                "Review the Terms and Conditions for details about subscription plans"
              )
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-436fad3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-436fad3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Get.vue
// module id = null
// module chunks = 